/**
 * @file Utility functions for unlimited sandboxes event logic and date validation
 */
import { formatDate } from '@@/bits/date'
import { isAppUsing } from '@@/bits/flip'
import { __ } from '@@/bits/intl'
import { LibraryType } from '@@/enums'
import { Library, User } from '@@/types'

const isPartOfUnlimitedSandboxesEvent = (): boolean => {
  // US Pacific (PST) → Dec 31, 4:00 AM
  // US Eastern (EST) → Dec 31, 7:00 AM
  // Singapore (SGT) → Dec 31, 8:00 PM
  return isAppUsing('unlimitedSandboxesV2') && new Date() < new Date(Date.UTC(2025, 11, 31, 12, 0, 0))
}

const UNLIMITED_SANDBOXES_EVENT_END_DATE_STRING = '2025-12-31'

const unlimitedSandboxesEventUtcEndDate = (options: Intl.DateTimeFormatOptions): string => {
  // Always display the event end date as December 31 (UTC), ensuring all users see a consistent date regardless of their local timezone.
  return formatDate(UNLIMITED_SANDBOXES_EVENT_END_DATE_STRING, {
    ...options,
    timeZone: 'UTC',
  })
}

const getUnlimitedSandboxesEventBadgeLabel = ({
  library,
  user,
}: {
  library: Library | Partial<Library> | null
  user: User
}): string | undefined => {
  return isPartOfUnlimitedSandboxesEvent() &&
    (library == null || library.libraryType === LibraryType.Solo) &&
    user.tenant_id === 1 &&
    user.membership_tier !== 'platinum'
    ? __('Unlimited until %{date}', {
        date: unlimitedSandboxesEventUtcEndDate({
          month: 'short',
          day: 'numeric',
        }),
      })
    : undefined
}

export { getUnlimitedSandboxesEventBadgeLabel, isPartOfUnlimitedSandboxesEvent, unlimitedSandboxesEventUtcEndDate }
